import lottie from 'lottie-web'
import loadingMotionData from '../../assets/lottie/loading-motion2.json'
import loadingMotionDarkData from '../../assets/lottie/loading-motion-dark2.json'

export default class Loading {
  constructor() {
    this.$t = window.$t
    this.loadingFlag = false
  }

  // eslint-disable-next-line class-methods-use-this
  setLoading({ title, description } = {}) {
    const loadingEl = document.querySelector('#loading')
    const loadingTitleEl = document.querySelector('#loading-title')
    const loadingDescEl = document.querySelector('#loading-desc')
    if (!loadingEl || !loadingTitleEl || !loadingDescEl) return

    const currentLanguage = window.$i18next.language
    if (currentLanguage === 'ar') {
      document.querySelector('.title-container').style['flex-direction'] = 'row-reverse'
      document.querySelector('.spinner2').style['flex-direction'] = 'row-reverse'
    }

    loadingTitleEl.innerText = title || ''
    loadingDescEl.innerText = description || ''
  }

  showLoading({ title, description } = {}) {
    this.setLoading({ title, description })

    if (this.loadingFlag) {
      return
    }

    this.loadingFlag = true

    const loadingEl = document.querySelector('#loading')
    loadingEl.style.transform = 'translate(0, 0)'

    // lottie 로딩 모션
    const loadingVideoEl = document.querySelector('#loading-video')
    if (loadingVideoEl.hasChildNodes()) return // 로딩 아이콘 한개만 노출

    const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    const animationData = isDarkMode ? loadingMotionDarkData : loadingMotionData
    lottie.loadAnimation({
      container: loadingVideoEl, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
    })
  }
}
